import { TableWrapper } from '@4beefopag/4bee-fopag-core/dist/atoms';
import styled from 'styled-components';

export const Wrapper = styled(TableWrapper)`
  padding: 8px;
  background-color: white;

  th {
    text-align: left;
  }
`;
